import {ListBox, ListBoxItem} from "react-aria-components";
import "./ErrorMessage.css"
import {LuAlertCircle} from "react-icons/lu";
import React, {useContext} from "react";
import {ErrorContext} from "../../utils/apiErrors.jsx";
import {getValidationError} from "../../utils/getValidationErrors";

function formatErrorMessage(validationError): string {
    const error_type = validationError.type;
    if (error_type === "string_type" || error_type === "missing" || error_type === "string_too_short") {
        return "Field Required";
    }
    if (error_type === "too_short") {
        if (validationError.loc[1] === "actions") {
            return "Field Required";
        }
        return "At least one option must be selected"
    }
    if (error_type.includes("pattern")) {
        return "Invalid email address"
    }
    return validationError.msg;
}

function WrappedWithErrorMessage({children, errorLoc, disabled}: {children: never, errorLoc: string[], disabled?: boolean}) {
    const {errors} = useContext(ErrorContext)
    const validationError = getValidationError(errorLoc, errors)

    if (!validationError) {
        return children
    }
    const message:string = formatErrorMessage(validationError)
    return <div className="error-container">
        {children}
        {!disabled &&
            <ListBox aria-label="wrapped error">
                <ListBoxItem textValue={message} className="error-message">
                    <LuAlertCircle className="error-icon"/>
                    <span className="error-text">{message}</span>
                </ListBoxItem>
            </ListBox>
        }
    </div>
}


export default WrappedWithErrorMessage